import { botApi } from './botApi'
import { IWithdrawDraft, TradeOption } from '../calcBot/types'
import { makeQueryParamString } from 'utils/utils'
import { IWithdraw } from './types'

export enum WithdrawSentByEnum {
  UNKNOWN = 'Unknown',
  BOT = 'Bot',
  FRONT = 'Front',
}

export const withdrawApi = botApi.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getBackups: query<number, any>({
      query: () => ({
        url: '/withdraws/backups',
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetBackupsQuery,
} = withdrawApi
